import translate from '@translate';
import React, { FC, useEffect, useState } from 'react';
import { ClaimType } from 'src/types/claim';
import FileUpload, { FilesPropType } from 'src/components/FileUpload';
import EntityFilesTable from 'src/components/FileUpload/EntityFilesTable';
import Typography from 'src/components/Typography';
import { sizes } from 'src/themes/default';
import { FileType } from '../../types/file';
import { FormErrorsType, OnChangeType } from '../../types/global';
import { EditKeysType } from './constants';

export interface DetailPropsType {
    onChange: OnChangeType<EditKeysType>;
    editData: ClaimType;
    editErrors: FormErrorsType;
    isAttributeEditDisabled: (attributeKey: string) => boolean;
    skladonUser?: number;
}

const FilesBlock: FC<DetailPropsType> = (props) => {
    const [invoiceFiles, setInvoiceFiles] = useState<FileType[]>([]);
    const [imageFiles, setImageFiles] = useState<FileType[]>([]);

    useEffect(() => {
        if (props.editData.FILES) {
            setInvoiceFiles(props.editData.FILES.filter((file) => file.type === 'invoice'));
            setImageFiles(props.editData.FILES.filter((file) => file.type === 'image'));
        }
    }, [props.editData.FILES]);

    const handleChange = (value: FilesPropType, error: boolean, type: string) => {
        let newFiles: FileType[] = [];
        if (type === 'image') {
            newFiles = [...invoiceFiles, ...value.map((valueItem) => ({ ...valueItem, type: 'image' }))];
        } else if (type === 'invoice') {
            newFiles = [...value.map((valueItem) => ({ ...valueItem, type: 'invoice' })), ...imageFiles];
        } else {
            newFiles = [...invoiceFiles, ...imageFiles];
        }
        props.onChange('FILES', newFiles, error);
    };

    const handleDelete = (file: FileType, type: 'invoice' | 'image') => {
        const remaining =
            type === 'invoice'
                ? invoiceFiles.filter((f) => f !== file)
                : imageFiles.filter((f) => f !== file);
        const other = type === 'invoice' ? imageFiles : invoiceFiles;
        props.onChange('FILES', type === 'invoice' ? [...remaining, ...other] : [...other, ...remaining], false);
    };

    const filesDisabled = props.isAttributeEditDisabled('FILES');

    return (
        <>
            <div style={{ paddingTop: sizes.body_PD, paddingBottom: sizes.body_PD }}>
                <FileUpload
                    label={translate('claimDetail.invoiceDocument')}
                    files={invoiceFiles}
                    onChange={(value, error) => handleChange(value, error, 'invoice')}
                    accept=".pdf,.xlsx,.doc,.docx,.txt,.pptx"
                    name="invoice"
                    error={props.editErrors.invoice}
                    height={130}
                    disabled={filesDisabled}
                    multiple
                    required
                    displayFilesList={false}
                    data-testid="claim-invoice-upload"
                />
                <EntityFilesTable
                    files={invoiceFiles}
                    disabled={filesDisabled}
                    onDeleteFile={(file) => handleDelete(file, 'invoice')}
                    skladonUser={props.skladonUser}
                    testIdPrefix="claim-invoice-files"
                />

                <Typography gutterBottom variant="body2">
                    <b>{translate('claimDetail.invoiceDocumentText1')}</b>
                    {translate('claimDetail.invoiceDocumentText2')}
                </Typography>
            </div>
            <FileUpload
                label={translate('claimDetail.image')}
                files={imageFiles}
                onChange={(value, error) => handleChange(value, error, 'image')}
                accept="image/jpeg,image/jpg,image/png"
                name="image"
                error={props.editErrors.image}
                height={130}
                disabled={filesDisabled}
                multiple
                displayFilesList={false}
            />
            <EntityFilesTable
                files={imageFiles}
                disabled={filesDisabled}
                onDeleteFile={(file) => handleDelete(file, 'image')}
                skladonUser={props.skladonUser}
                testIdPrefix="claim-image-files"
            />

            <Typography gutterBottom variant="body2">
                <b>{translate('claimDetail.invoiceImageDocumentText1')}</b>
                {translate('claimDetail.invoiceImageDocumentText2')}
            </Typography>
        </>
    );
};

export default FilesBlock;
